import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PaymentIcon from '@mui/icons-material/Payment';
import PeopleIcon from '@mui/icons-material/People';
import RedeemIcon from '@mui/icons-material/Redeem';
import DevicesIcon from '@mui/icons-material/Devices';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import BarChartIcon from '@mui/icons-material/BarChart';
import ConnectedTvIcon from '@mui/icons-material/ConnectedTv';
import { ComponentType } from 'react';

export type MenuGroupId = 'offers' | 'messaging' | 'stores' | 'admin';

export interface MenuItem {
  path: string;
  label: string;
  roles: string[];
  icon: ComponentType;
  group: MenuGroupId;
}

export interface MenuGroup {
  id: MenuGroupId;
  label: string;
  items: MenuItem[];
}

// Groups appear in the side navigation in this order.
export const menuGroupOrder: { id: MenuGroupId; label: string }[] = [
  { id: 'offers', label: 'Offers' },
  { id: 'messaging', label: 'Messaging' },
  { id: 'stores', label: 'Stores' },
  { id: 'admin', label: 'Admin' }
];

export const menuItems: MenuItem[] = [
  { path: '/coupons', label: 'Coupons', roles: ['coupon:view', 'coupon:tester', 'coupon:edit', 'coupon:admin'], icon: LocalOfferIcon, group: 'offers' },
  { path: '/redemptions', label: 'Redemptions', roles: ['reports', 'redeemer'], icon: RedeemIcon, group: 'offers' },
  { path: '/notifications', label: 'Notifications', roles: ['notification:view', 'notification:tester', 'notification:edit', 'notification:admin'], icon: NotificationsIcon, group: 'messaging' },
  { path: '/custom-push', label: 'Custom Push', roles: ['custom-push:view', 'custom-push:admin'], icon: VpnKeyIcon, group: 'messaging' },
  { path: '/push-dashboard', label: 'Push Stats', roles: ['custom-push:view', 'custom-push:admin', 'notification:view'], icon: BarChartIcon, group: 'messaging' },
  { path: '/visits', label: 'Visits', roles: ['visit:view'], icon: LocationOnIcon, group: 'stores' },
  { path: '/recordVisits', label: 'Record Visits', roles: ['visit:view'], icon: AddLocationIcon, group: 'stores' },
  { path: '/signage', label: 'Signage', roles: ['signage:view', 'signage:admin', 'admin'], icon: ConnectedTvIcon, group: 'stores' },
  { path: '/users', label: 'Users', roles: ['admin'], icon: PeopleIcon, group: 'admin' },
  { path: '/payments', label: 'Payments', roles: ['admin'], icon: PaymentIcon, group: 'admin' },
  { path: '/devices', label: 'Devices', roles: ['token:view'], icon: DevicesIcon, group: 'admin' }
];

/** Groups the given (already role-filtered) items for the side navigation; empty groups are dropped. */
export const groupMenuItems = (items: MenuItem[]): MenuGroup[] =>
  menuGroupOrder
    .map((group) => ({ ...group, items: items.filter((item) => item.group === group.id) }))
    .filter((group) => group.items.length > 0);

export default menuItems;
